// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-2lCmlUIZ","foot_link":"foot_link-1R3SaBld","list":"list-1oky3MbR","link":"link-3fRC5ikO","copyright":"copyright-3ViNOcS-"};